import type { FaireProductEntity } from "../../entity_types/product";

export const p_hpg8p7p5jh: FaireProductEntity = {
  token: "p_hpg8p7p5jh",
  type: "product",
  name: "HAWAII Postcard Booklet",
  brandName: "Found Image Press",
  imageUrl:
    "https://cdn.faire.com/fastly/5c20d7adeeea8385f5318a7ffb3dd9344c55f579fba214c5f4acf653d2e7f59a.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7fec78da0d2ee85e75372a8d43bf9ad9993e556cc4b1916a3b7ae37f86d75fe0.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
